import classNames from 'classnames'
import * as React from 'react'

import TransformText from '../../../containers/TransformText'
import {useUserDisplayName} from '../../../hooks/useUserDisplayName'
import SvgIcon from '../SvgIcon/SvgIcon'

import type {Props} from './BuildCanceled.types'

import styles from './BuildCanceled.css'

const MIN_LINES = 3

function BuildCanceled({className, buildTypeId, user, text, canceled, compact, withIcon}: Props) {
  const userDisplayName = useUserDisplayName(user, true)
  return canceled ? (
    <div className={classNames(className, styles.wrapper)}>
      {withIcon === true && <SvgIcon icon="cancel" className={styles.icon} />}
      <div>
        <span>
          {'Canceled'}
          {userDisplayName != null ? ` by ${userDisplayName}` : ''}
          {text != null ? ':' : ''}
        </span>
        {text != null && (
          <TransformText
            text={text}
            lines={compact ? MIN_LINES : null}
            lineHeight={16}
            buildTypeId={buildTypeId}
          />
        )}
      </div>
    </div>
  ) : null
}

export default React.memo<Props>(BuildCanceled)
